import React from 'react';
import { Link, Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { PLATFORM_OVERVIEW_PATH } from '../auth/postLoginRouting';

function RequireTenantPermission({ permission, children }) {
  const {
    sessionLoading,
    activeTenant,
    hasTenantPermission,
    hasPlatformAccess,
  } = useAuth();

  if (sessionLoading) {
    return <div className="loading-state">Loading…</div>;
  }

  if (!activeTenant) {
    if (hasPlatformAccess) {
      return <Navigate to={PLATFORM_OVERVIEW_PATH} replace />;
    }
    return (
      <div className="console-forbidden">
        <h2>No Partner workspace</h2>
        <p>You need an active Partner membership to access the Partner Console.</p>
        <p>
          <Link to="/console/partners/new">Create Partner workspace</Link>
        </p>
      </div>
    );
  }

  if (permission && !hasTenantPermission(permission)) {
    return <Navigate to="/console" replace />;
  }

  return children || <Outlet />;
}

export default RequireTenantPermission;
